import { Box, Flex, Icon } from "@chakra-ui/react";

const BlogRightArrowIcon = ({ size = "20px", color = "white", ...props }) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4549 31.1213C16.0646 30.7311 16.0643 30.0985 16.4541 29.7079L24.1452 22L16.4541 14.2921C16.0643 13.9015 16.0646 13.2689 16.4549 12.8787L17.6264 11.7071C18.017 11.3166 18.6501 11.3166 19.0406 11.7071L28.6264 21.2929C29.017 21.6834 29.017 22.3166 28.6264 22.7071L19.0406 32.2929C18.6501 32.6834 18.017 32.6834 17.6264 32.2929L16.4549 31.1213Z"
        fill={color}
      />
      <rect
        x="1"
        y="1"
        width="42"
        height="42"
        rx="15"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};
export default BlogRightArrowIcon;
